import './Divider.css';

function Divider({ icon = '✙', color = '#b8a58a' }) {
  return (
    <div className="divider-wrapper">
      <hr className="divider-line" style={{ background: `linear-gradient(to right, transparent, ${color}, transparent)` }} />
      <span className="divider-icon" style={{ color }}>{icon}</span>
      <hr className="divider-line" style={{ background: `linear-gradient(to right, transparent, ${color}, transparent)` }} />
    </div>
  );
}

export default Divider;